import Vue from "vue";
import "vant/lib/cell-group/style";
import "vant/lib/field/style";
import "vant/lib/datetime-picker/style";
import "vant/lib/icon/style";
import { CellGroup, Field, DatetimePicker, Icon } from "vant";
import moment from "moment";
Vue.use(CellGroup)
  .use(Field)
  .use(DatetimePicker)
  .use(Icon);
const datePickerWapMixin = {
  name: "sk-date-picker-wap",
  props: {
    field: {},
    fieldValue: "",
    fieldResult: {},
    checkFlag: false
  },
  data() {
    return {
      // 是否显示选择框
      isShowDatePicker: false,
      fieldObj: {},
      timeValue: this.fieldValue ? new Date(this.fieldValue) : null,
      minDate: this.getYears(100).minDate,
      maxDate: this.getYears(50).maxDate,
      dateType: "date"
    };
  },
  watch: {
    checkFlag() {
      //校验
      this.fieldObj.dirty = true;
      //输出结果到父级
      this.$emit("update:fieldValue", {
        VerifyFail: this.fieldObj.dirty && this.fieldObj.invalid,
        fieldName: this.fieldObj.fieldName,
        value:
          this.field.dateLimitType == "MONTH" ||
          this.field.dateLimitType == "YEAR"
            ? new Date(this.fieldDate)
            : moment(this.fieldDate).format('YYYY-MM-DD HH:mm')
      });
      this.$emit("update:fieldResult", this.fieldObj);
    },
    isShowDatePicker(val) {
      if (val) {
        this.timeValue = this.timeValue
          ? moment(this.timeValue).format(this.fieldObj.format)
          : new Date();
      }
    }
  },
  created() {
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = "请选择";
    }
    this.fieldObj = new window.$sk.DateTime(this.field);
    // 不是读写权限禁用
    this.fieldObj.disabled = this.field.permissionType && this.field.permissionType != 'write';
    switch (this.field.accuracy || this.field.dateLimitType) {
      case "MINUTE":
        this.dateType = "datetime";
        this.fieldObj.format = this.field.dateLimitType
          ? this.fieldObj.format
          : "YYYY-MM-DD HH:mm";
        break;
      case "HOUR":
        this.dateType = "datehour";
        this.fieldObj.format = this.field.dateLimitType
          ? this.fieldObj.format
          : "YYYY-MM-DD HH";
        break;
      case "DAY":
        this.dateType = "date";
        this.fieldObj.format = this.field.dateLimitType
          ? this.fieldObj.format
          : "YYYY-MM-DD";
        break;
      case "MONTH":
        this.dateType = "year-month";
        this.fieldObj.format = this.field.dateLimitType
          ? this.fieldObj.format
          : "YYYY-MM";
        break;
      case "YEAR":
        this.dateType = "year-month";
        this.fieldObj.format = this.field.dateLimitType
          ? this.fieldObj.format
          : "YYYY";
        break;
    }
    if (this.fieldDate) this.fieldObj.setValue(this.fieldDate);
  },
  computed: {
    fieldDate() {
      return this.timeValue
        ? moment(this.timeValue).format(this.fieldObj.format)
        : null;
    },
    titleTxt() {
      return "请选择" + this.fieldObj.displayName;
    }
  },
  methods: {
    // 取消选择
    cancel() {
      this.timeValue = null;
      this.isShowDatePicker = false;
      this.updateValue();
    },
    handleChange() {
      this.updateValue();
    },
    confirm() {
      this.isShowDatePicker = false;
      this.updateValue();
    },

    // 更新数据
    updateValue() {
      this.fieldObj.setValue(this.fieldDate);
      this.$emit("change",{
        displayType:this.fieldObj.displayType,
        value: this.timeValue,
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy
      });
    },
    // 设置选择时间范围
    getYears(yearNum) {
      let date = new Date();
      let minYear = date.getFullYear() - yearNum;
      let maxYear = date.getFullYear() + yearNum;
      return {
        minDate: new Date(minYear + "/01/01 00:00"),
        maxDate: new Date(maxYear + "/12/31 23:59")
      };
    },
    // 初始化选择器内容
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      } else if (type === "hour") {
        return `${val}时`;
      } else if (type === "minute") {
        return `${val}分`;
      }
      return val;
    }
  }
};
export default datePickerWapMixin;
